require('./multiVmConfiguration.style.scss');

const HELP_ID = { PREPOST: 'prepost_scripts', FLR: 'flr' };
class MultiVmConfigurationController {
    constructor(
        $scope,
        $element,
        $timeout,
        $q,
        $filter,
        $rootScope,
        virtualMachinesPersistence,
        notificationService,
        utilsService,
        validationsService
    ) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.persistence = virtualMachinesPersistence;
        this.notificationService = notificationService;
        this.utilsService = utilsService;
        this.validationsService = validationsService;
        this.showSnapshotScriptDialog = false;

        this.pathPattern = this.validationsService.getPrePostScriptPattern();

        this.modalTitle = this.$filter('translate')('vm.configuration.multi.title');
    }

    $onInit() {
        this.setActionButtons();
        this.DEFAULT_OS = this.utilsService.getDefaultOS();
        this.baseInitialization();
    }

    onOpen() {
        this.load();
    }

    load() {
        this.busy = true;
        this.preSnapshotScriptPathList = [];
        this.postSnapshotScriptPathList = [];
        this.someVirtualMachinesNotDiscovered = this.areSomeVmsNotDiscovered();
        this.everyVirtualMachineNotDiscovered = this.isEveryVmNotDiscovered();

        const virtualMachinesUuids = this.getVirtualMachinesUuids();
        this.persistence.getMultiVirtualMachineConfiguration(virtualMachinesUuids).then((res) => {
            this.configResponse = res.entities[0];
            this.preSnapshotWarningMessage = this.$filter('translate')(
                'vm.configuration.multi.script.pre.snapshot.warning.label',
                { value: this.configResponse.assignedPreSnapshotCommandsCount.toString() }
            );
            this.postSnapshotWarningMessage = this.$filter('translate')(
                'vm.configuration.multi.script.pre.snapshot.warning.label',
                { value: this.configResponse.assignedPostSnapshotCommandsCount.toString() }
            );
            this.numberOfSelectedVms = this.configResponse.virtualMachinesUuids.length;
            let assignedPreSnapshotCommands =
                this.configResponse &&
                this.configResponse.assignedPreSnapshotCommands &&
                this.configResponse.assignedPreSnapshotCommands.length > 0
                    ? this.configResponse.assignedPreSnapshotCommands
                    : null;
            let assignedPostSnapshotCommands =
                this.configResponse &&
                this.configResponse.assignedPostSnapshotCommands &&
                this.configResponse.assignedPostSnapshotCommands.length > 0
                    ? this.configResponse.assignedPostSnapshotCommands
                    : null;
            if (assignedPreSnapshotCommands) {
                this.preSnapshotScriptPathList = assignedPreSnapshotCommands
                    .map((item) => {
                        return { value: item, label: item };
                    })
                    .filter((script) => script.value !== '' && script.value !== null);
                this.preSnapshotScriptPathCopy = [...this.preSnapshotScriptPathList];
            }
            if (assignedPostSnapshotCommands) {
                this.postSnapshotScriptPathList = assignedPostSnapshotCommands
                    .map((item) => {
                        return { value: item, label: item };
                    })
                    .filter((script) => script.value !== '' && script.value !== null);
                this.postSnapshotScriptPathCopy = [...this.postSnapshotScriptPathList];
            }
            this.arePreSnapshotScriptsMixed();
            this.arePostSnapshotScriptsMixed();
            this.disableRestoreIndividualFilesOptions(this.configResponse);

            if (this.preSnapshotScript !== undefined) {
                this.initialPreScript = this.preSnapshotScript.value;
            } else {
                this.initialPreScript = null;
            }

            if (this.postSnapshotScript !== undefined) {
                this.initialPostScript = this.postSnapshotScript.value;
            } else {
                this.initialPostScript = null;
            }
            this.setListeners();
            this.busy = false;
        });
    }

    arePreSnapshotScriptsMixed() {
        if (this.configResponse && this.configResponse.mixedPreSnapshots) {
            this.preSnapshotScript = {
                value: 'MIXED',
                label: 'Mixed',
            };
            this.preSnapshotScriptMixed = true;
        }
        if (
            this.configResponse &&
            this.configResponse.assignedPreSnapshotCommands &&
            this.configResponse.assignedPreSnapshotCommands.length === 1 &&
            !this.configResponse.mixedPreSnapshots
        ) {
            this.preSnapshotScript = this.preSnapshotScriptPathList[0];

            this.preSnapshotScriptMixed = false;
        }
    }

    arePostSnapshotScriptsMixed() {
        if (this.configResponse && this.configResponse.mixedPostSnapshots) {
            this.postSnapshotScript = {
                value: 'MIXED',
                label: 'Mixed',
            };
            this.postSnapshotScriptMixed = true;
        }
        if (
            this.configResponse &&
            this.configResponse.assignedPostSnapshotCommands &&
            this.configResponse.assignedPostSnapshotCommands.length === 1 &&
            !this.configResponse.mixedPostSnapshots
        ) {
            this.postSnapshotScript = this.postSnapshotScriptPathList[0];

            this.postSnapshotScriptMixed = false;
        }
    }

    areSomeVmsNotDiscovered() {
        if (this.selectedVms.some((vm) => vm.discoveryStatus !== 'OK')) {
            return true;
        } else return false;
    }

    isEveryVmNotDiscovered() {
        if (this.selectedVms.every((vm) => vm.discoveryStatus !== 'OK')) {
            return true;
        } else return false;
    }

    disableRestoreIndividualFilesOptions(configResponse) {
        const everyVirtualMachineHasCatalogCreationEnabled = configResponse.allEnabledFlr;
        const everyVirtualMachineHasCatalogCreationDisabled = configResponse.allDisabledFlr;

        if (everyVirtualMachineHasCatalogCreationEnabled) {
            this.restoreIndividualFilesOptions[0].disabled = true;
            this.restoreIndividualFilesOptionsTooltipText[0] = this.$filter('translate')(
                'vm.configuration.multi.restoreIndividualFiles.enable.warning.message.disabled'
            );
        }
        if (everyVirtualMachineHasCatalogCreationDisabled) {
            this.restoreIndividualFilesOptions[1].disabled = true;
            this.restoreIndividualFilesOptionsTooltipText[1] = this.$filter('translate')(
                'vm.configuration.multi.restoreIndividualFiles.disabled.warning.message.disabled'
            );
        }
    }

    setActionButtons() {
        this.actionButtons = [
            {
                title: this.$filter('translate')('toolbar.default.save.label'),
                action: () => this.save(),
                isDisabled: () => this.isDisabled(),
            },
        ];
    }

    onTabChange(previous, active) {
        return this.$q((resolve) => {
            if (previous !== active) {
                this.previousActiveTab = previous;
                this.tabsFormValid[previous] = this.dialogForm.$valid;
            }
            if (active == 'tab1') {
                this.helpId = HELP_ID.FLR; //todo
            } else if (active == 'tab0') {
                this.helpId = HELP_ID.PREPOST; //todo
            }
            resolve();
        });
    }

    baseInitialization() {
        this.preSnapshotScriptAlreadyAdded = false;
        this.postSnapshotScriptAlreadyAdded = false;
        this.restoreIndividualFilesOptionsTooltipText = [];
        this.copySearchPostSnapshotScript = {};
        this.copySearchPreSnapshotScript = {};
        this.activeTab = 1;
        this.previousActiveTab = null;
        this.tabsFormValid = {};
        this.configResponse = null;
        this.preSnapshotWarningMessage = null;
        this.postSnapshotWarningMessage = null;
        this.someVirtualMachinesNotDiscovered = null;
        this.everyVirtualMachineNotDiscovered = null;
        this.numberOfSelectedVms = null;
        this.restoreIndividualFiles = null;
        this.postSnapshotScriptPathCopy = [];
        this.preSnapshotScriptPathCopy = [];
        this.initialPreScript = '';
        this.initialPostScript = '';

        this.restoreIndividualFilesOptions = [
            {
                name: this.$filter('translate')('vm.configuration.multi.restoreIndividualFiles.enable.label'),
                value: 'true',
            },
            {
                name: this.$filter('translate')('vm.configuration.multi.restoreIndividualFiles.disable.label'),
                value: 'false',
            },
        ];
    }

    getVirtualMachinesUuids() {
        return this.selectedVms.map((vm) => vm.uuid);
    }

    save() {
        this.busy = true;
        const data = {
            virtualMachinesUuids: this.configResponse.virtualMachinesUuids,
            postSnapshotCommand:
                this.postSnapshotScript && this.postSnapshotScript.value ? this.postSnapshotScript.value : '',
            preSnapshotCommand:
                this.preSnapshotScript && this.preSnapshotScript.value ? this.preSnapshotScript.value : '',
            catalogCreation: !this.restoreIndividualFiles
                ? null
                : this.restoreIndividualFiles === 'true'
                ? true
                : false,
            overridePreSnapshotCommand: this.overRidePreSnapshotScript ? true : false,
            overridePostSnapshotCommand: this.overRidePostSnapshotScript ? true : false,
        };

        this.persistence
            .saveMultiVirtualMachinesConfiguration(data)
            .then((res) => {
                this.busy = false;
                this.notificationService.pop(res.data.message);
            })
            .finally(() => {
                this.showModal = false;
            });
    }

    addNewPreSnapshotScript() {
        this.showSnapshotScriptDialog = true;
        this.addSnapshotScriptDialogTitle = this.$filter('translate')(
            'vm.configuration.multi.add.pre.snapshot.script.dialog.title'
        );
        this.snapshotDialogType = 'pre';
    }

    addNewPostSnapshotScript() {
        this.showSnapshotScriptDialog = true;
        this.addSnapshotScriptDialogTitle = this.$filter('translate')(
            'vm.configuration.multi.add.post.snapshot.script.dialog.title'
        );
        this.snapshotDialogType = 'post';
    }

    addSnapshotScript(script) {
        if (!script) {
            return;
        }
        this.showSnapshotScriptDialog = false;
        if (this.snapshotDialogType === 'pre') {
            if (this.preSnapshotScriptPathList.filter((item) => item.value === script).length) {
                this.notificationService.pop({
                    type: 'warning',
                    title: this.$filter('translate')(
                        'vm.configuration.multi.add.pre.snapshot.script.dialog.warning.message'
                    ),
                });
                return;
            }

            let newPreSnapshotList = [...this.preSnapshotScriptPathList];
            newPreSnapshotList.unshift({ value: script, label: script });
            this.preSnapshotScriptPathList = newPreSnapshotList;
            this.preSnapshotScriptPathCopy = [...this.preSnapshotScriptPathList];
            this.preSnapshotScript = { value: script, label: script };
            this.addedPreSnapshotScript = { value: script, label: script };
            this.preSnapshotScriptAlreadyAdded = true;
        }
        if (this.snapshotDialogType === 'post') {
            if (this.postSnapshotScriptPathList.filter((item) => item.value === script).length) {
                this.notificationService.pop({
                    type: 'warning',
                    title: this.$filter('translate')(
                        'vm.configuration.multi.add.post.snapshot.script.dialog.warning.message'
                    ),
                });
                return;
            }
            let newPostSnapshotList = [...this.postSnapshotScriptPathList];
            newPostSnapshotList.unshift({ value: script, label: script });
            this.postSnapshotScriptPathList = newPostSnapshotList;
            this.postSnapshotScriptPathCopy = [...this.postSnapshotScriptPathList];
            this.postSnapshotScript = { value: script, label: script };
            this.addedPostSnapshotScript = { value: script, label: script };
            this.postSnapshotScriptAlreadyAdded = true;
        }
    }

    searchPreSnapshotScript() {
        this.preSnapshotScriptPathList = this.preSnapshotScriptPathCopy.filter(
            (target) =>
                target.label.toLowerCase().indexOf(this.copySearchPreSnapshotScript.searchBy.toLowerCase()) !== -1
        );
    }

    searchPostSnapshotScript() {
        this.postSnapshotScriptPathList = this.postSnapshotScriptPathCopy.filter(
            (target) =>
                target.label.toLowerCase().indexOf(this.copySearchPostSnapshotScript.searchBy.toLowerCase()) !== -1
        );
    }

    setListeners() {
        this.preSnapshotScriptListener = this.$scope.$watch(
            () => this.preSnapshotScript,
            (newVal, oldVal) => {
                if (
                    Array.isArray(newVal) &&
                    this.addedPreSnapshotScript &&
                    JSON.stringify({ value: oldVal.value, label: oldVal.label }) ===
                        JSON.stringify(this.addedPreSnapshotScript)
                ) {
                    this.preSnapshotScriptPathList = this.preSnapshotScriptPathList.filter(
                        (item) => item.value !== this.addedPreSnapshotScript.value
                    );
                    this.postSnapshotScriptPathCopy = [...this.preSnapshotScriptPathList];
                    this.preSnapshotScriptAlreadyAdded = false;
                    this.addedPreSnapshotScript = null;
                }
                if (
                    newVal &&
                    !this.addedPreSnapshotScript &&
                    this.preSnapshotScriptPathList.filter((item) => item.value === newVal.value).length > 0
                ) {
                    this.preSnapshotScriptAlreadyAdded = false;
                }
            },
            true
        );
        this.postSnapshotScriptListener = this.$scope.$watch(
            () => this.postSnapshotScript,
            (newVal, oldVal) => {
                if (
                    Array.isArray(newVal) &&
                    this.addedPostSnapshotScript &&
                    JSON.stringify({ value: oldVal.value, label: oldVal.label }) ===
                        JSON.stringify(this.addedPostSnapshotScript)
                ) {
                    this.postSnapshotScriptPathList = this.postSnapshotScriptPathList.filter(
                        (item) => item.value !== this.addedPostSnapshotScript.value
                    );
                    this.postSnapshotScriptPathCopy = [...this.postSnapshotScriptPathList];
                    this.preSnapshotScriptAlreadyAdded = false;
                    this.addedPostSnapshotScript = null;
                }
                if (
                    newVal &&
                    !this.addedPostSnapshotScript &&
                    this.postSnapshotScriptPathList.filter((item) => item.value === newVal.value).length > 0
                ) {
                    this.postSnapshotScriptAlreadyAdded = false;
                }
            },
            true
        );
    }

    onClose() {
        this.clearListeners();
    }

    clearListeners() {
        if (this.postSnapshotScriptListener) this.postSnapshotScriptListener();
        if (this.preSnapshotScriptListener) this.preSnapshotScriptListener();
    }

    isDisabled() {
        return (
            this.busy ||
            !this.dialogForm ||
            !this.dialogForm.$valid ||
            (this.previousActiveTab && !this.tabsFormValid['tab0'])
        );
    }
}

MultiVmConfigurationController.$inject = [
    '$scope',
    '$element',
    '$timeout',
    '$q',
    '$filter',
    '$rootScope',
    'virtualMachinesPersistence',
    'notificationService',
    'utilsService',
    'validationsService',
];

const multiVmConfigurationComponent = {
    controller: MultiVmConfigurationController,
    template: require('./multiVmConfiguration.template.html'),
    bindings: {
        showModal: '=',
        onClosed: '&',
        selectedVms: '=',
    },
};

module.exports = multiVmConfigurationComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/dialogs/multiVmConfiguration/multiVmConfiguration.component.js